import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AuditReasonDialogData {
  title: string;
  entityName?: string;
  confirmLabel?: string;
  danger?: boolean;
}

@Component({
  selector: 'app-audit-reason-dialog',
  templateUrl: './audit-reason-dialog.component.html',
  styleUrls: ['./audit-reason-dialog.component.css']
})
export class AuditReasonDialogComponent {

  presetReasons: string[] = [
    'No longer needed',
    'Created by mistake',
    'Duplicate',
    'Replaced by a new record',
    'Customer / employee left',
    'Other'
  ];

  selectedPreset: string | null = null;
  otherReason = '';

  constructor(
    public dialogRef: MatDialogRef<AuditReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AuditReasonDialogData
  ) {}

  isValid(): boolean {
    if (!this.selectedPreset) return false;
    if (this.selectedPreset === 'Other') return this.otherReason.trim().length > 0;
    return true;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (!this.isValid()) return;
    const reason = this.selectedPreset === 'Other'
      ? this.otherReason.trim()
      : this.selectedPreset;
    this.dialogRef.close({ reason });
  }
}
